'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.linkedMeVideoApp = void 0;
var linkedMeVideoApp = function (e, n, o) {
    if (!e || !window.linkedme)
        return console.log('检查是否配置option相关参数以及linkedme包的引入'), !1;
    var i = {
        params: JSON.stringify(e),
        type: 'live'
    };
    try {
        window.linkedme.link(i, function (e, i) {
            e || !i.url ? console.log(e, 'linkme链接生成失败') : (n && (n.setAttribute('href', i.url), n.addEventListener('click', function () {
                window.linkedme.trigger_deeplink(i.url);
            })), o && o(i.url));
        }, !1);
    } catch (e) {
        console.log(e, 'linkme链接生成失败');
    }
};
exports.linkedMeVideoApp = linkedMeVideoApp;